import { RichTextType, StateColumnMultipleType, StateColumnSingleType, StateColumnSwitchType, TextInputType } from "@/components/UI/tools";

const blacklist = ["speaker_profile"]; // Example blacklist of attributes to ignore

export const useAttributesUnfurler = (
    attributes: Record<string, any> | undefined,
    onChange: (key: string, value: any) => void
) => {
    const refColumns: (TextInputType | RichTextType)[] = [];
    const stateColumns: (StateColumnMultipleType | StateColumnSingleType | StateColumnSwitchType)[] = [];

    if (!attributes) return { refColumns, stateColumns };

    Object.entries(attributes).forEach(([key, value]) => {
        if (blacklist.includes(key)) return;

        const updateAttribute = (val: any) => {
            onChange(key, val);
        };

        if (typeof value === "string") {
            refColumns.push({
                type: value.length > 50 || value.includes("\n") ? "richtext" : "text",
                label: key,
                value: value,
                onChange: updateAttribute,
                validator: () => true,
            } as TextInputType | RichTextType);
        } else if (typeof value === "boolean") {
            stateColumns.push({
                type: "switch",
                label: key,
                value: value ? "true" : "false",
                items: [{ name: "true" }, { name: "false" }],
                onChange: (newVal) => updateAttribute(newVal === "true"),
                validator: () => true,
            } as StateColumnSwitchType);
        } else if (typeof value === "number") {
            refColumns.push({
                type: "text",
                label: key,
                value: value.toString(),
                onChange: (v) => updateAttribute(Number(v)),
                validator: (v) => !isNaN(Number(v)),
            } as TextInputType);
        } else if (Array.isArray(value)) {
            // For simple string/number arrays
            stateColumns.push({
                type: "multiple",
                label: key,
                value: value,
                items: value.map((v, i) => ({ id: v, name: String(v) })),
                onChange: updateAttribute,
                validator: () => true,
            } as unknown as StateColumnMultipleType);
        } else if (typeof value === "object" && value !== null) {
            // Complex objects could be represented as JSON string in richtext
            refColumns.push({
                type: "richtext",
                label: key,
                value: JSON.stringify(value, null, 2),
                onChange: (v) => {
                    try {
                        updateAttribute(JSON.parse(v));
                    } catch (e) {
                        // wait for valid JSON
                    }
                },
                validator: (v) => {
                    try {
                        JSON.parse(v);
                        return true;
                    } catch (e) {
                        return false;
                    }
                },
            } as RichTextType);
        }
    });

    return { refColumns, stateColumns };
};
